export enum AdminDomain {
  permissions = 'permissions',
  stagedTags = 'stagedTags'
}
